//
//
//
//
//
//

  import grpc from '@/api/request'
  import {getSignature} from '@/controller/basic'
  export default {
    name: 'app',
    data () {
      return {
        appId: 'wx007c0d3fb6f94ab0',
        linkUrl: 'https://event.kuaipiyun.com/',
        transitionName: '',
        loading: true,
        loaindgText: '',
        path: '/',
        // 当前登录账号的coropration
        loginCoropration: {},
        getCorpration: false,
        wxloginLink: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx007c0d3fb6f94ab0&redirect_uri=' +
      encodeURIComponent('https://event.kuaipiyun.com/') +
        '&response_type=code&scope=snsapi_userinfo&state=1234#wechat_redirect',
        wxloginLinkTest: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx390e7cd501e61f98&redirect_uri=' +
          encodeURIComponent('https://event.kuaipitest.com') +
          '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect',
        isDoneWxShare: false
        // wxloginLink: '?code=081ivnXi12xl9v0PBDVi1B25Xi1ivnX9&state=agent123'
      }
    },
    created () {
      if (!this.isWx) {
        return
      }
      if (window.location.href.includes('kuaipitest')) {
        this.appId = 'wx390e7cd501e61f98'
        this.linkUrl = 'https://event.kuaipitest.com'
      }
      let includeCode = window.location.href.includes('?code=');
      if (!includeCode) {
        let clueId = this.$route.query.clueId
        if(clueId) {
          localStorage.getASIByUrl = this.$route.query.agentStaffId
          localStorage.agentId = this.$route.query.agentId
          localStorage.clueId = clueId
          localStorage.mainIndustryId = this.$route.query.mainIndustryId
          localStorage.corpVersion1 = this.$route.query.corpVersion1
          localStorage.corpPlugin = this.$route.query.corpPlugin 
        }
        if (window.location.href.includes('kuaipitest')) {
          window.location.href = this.wxloginLinkTest
        } else {
          window.location.href = this.wxloginLink
        }
      } else {
        this.wxShare()
        this.getAppId()
      }
    },
    mounted () {
    },
    methods: {
      getAppId() {
        if (!sessionStorage.token) {
          // 微信授权登陆后链接重定向，检测路径中是否包含code值
          if (window.location.href.includes('localhost')) {
            // 线下环境模拟转跳code地址,正常在mounted钩子完成
            // 在此处替换线下手动获取的code值
            this.wxloginLink = '?code=061nSA7E1Nuvu60GAb9E1CjD7E1nSA77&state=agent123'
            this.$router.push({path: this.wxloginLink})
          } else {
            // 访问valid接口
            let getcode = window.location.href.split('?code=')[1].split('&state')[0] || ''
            let getappId = window.location.href.includes('localhost') ? 'wx9fd51801e57d0c4d' : window.location.href.includes('kuaipitest') ? 'wx390e7cd501e61f98' : 'wx007c0d3fb6f94ab0'
            grpc.call('/auth/agent/invite/register/validate', {
              // 此处要区分线上线下不同的appid,线上appid:wx007c0d3fb6f94ab0,线下：6.0admin的appid:wx9fd51801e57d0c4d
              appId: getappId,
              code: getcode,
              agentStaffId: localStorage.getASIByUrl
            })
            .then(response => {
              if (response.code === 0) {
                if (response.data.type === 1) {
                  sessionStorage.setItem('openId', response.data.openId)
                  sessionStorage.setItem('token', response.data.token)
                  localStorage.agentType = response.data.agentType
                  // 转跳到绑定手机邮箱的页面
                  this.$router.push({
                    path: '/login'
                  })
                } else if (response.data.type === 2) {
                  // 已经绑定过的微信账号，进行登陆
                  sessionStorage.setItem('openId', response.data.openId)
                  sessionStorage.setItem('token', response.data.token)
                  sessionStorage.setItem('accountEmail', response.data.accountEmail)
                  sessionStorage.setItem('accountPhone', response.data.accountPhone)
                  if (response.data.apiUrl) {
                    localStorage.apiUrl = response.data.apiUrl
                    let urlArr = response.data.staticUrl.match(/^http[s]{0,1}:\/\/(.*?)(\/.*?)\//)
                    let after = urlArr[2] || ''
                    location.href = `${window.location.origin}${after}/`
                    return
                  }
                  // 设置临时token
                  grpc.config({
                    token: response.data.token
                  })
                  this.$router.push({path: '/corpList'})
                }
              } else {
                this.$vux.toast.show({
                  text: response.code + ',' + response.msg + ',' + response.requestId,
                  type: 'warn',
                  width: '200px',
                  position: 'middle',
                  time: 2000
                })
              }
            })
            .catch(error => {
              this.$vux.toast.show({
                text: '验证接口报错' + error,
                type: 'warn',
                width: '200px',
                position: 'middle',
                time: 2000
              })
            })            
          }
        } else {
          // 有token的情况下，直接进入corplist.vue企业列表页面
          // 考虑staffDetail的时效性，关闭网页是否清空
          if (localStorage.apiUrl) {
            grpc.instance.defaults.baseURL = localStorage.apiUrl
          }
          grpc.config({
            token: sessionStorage.token
          })
          this.$router.push({path: '/corpList'})
        }
      },
      wxShare () {
        let wxdata = {
          config: {
            appId: this.appId,
            timestamp: parseInt((new Date().getTime() / 1000)),
            nonceStr: Math.random().toString(36).substr(2),
            signature: '',
            jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'openAddress'],
            url: window.location.href.split('#')[0]
          }
        }
        getSignature({
          ...wxdata.config,
          callback: (response) => {
            wxdata.config.signature = response.data
            let timer = setInterval(() => {
              if (wxdata.config.signature) {
                wx.config(wxdata.config)
                wx.ready(() => {
                  wx.onMenuShareAppMessage({
                    title: '邀请你使用快批', // 分享标题
                    desc: '用快批极速开单，轻松管店',
                    link: `${this.linkUrl}#/?agentStaffId=${localStorage.getASIByUrl}&agentId=${localStorage.agentId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: 'https://kp7files.oss-cn-shanghai.aliyuncs.com/1/ab57c441-6d27-43a5-92ad-bf5a1891f747.png', // 分享图标
                    success: function () {
                    }
                  })
                  wx.onMenuShareTimeline({
                    title: '邀请你使用快批', // 分享标题
                    link: `${this.linkUrl}#/?agentStaffId=${localStorage.getASIByUrl}&agentId=${localStorage.agentId}`,
                    imgUrl: 'https://kp7files.oss-cn-shanghai.aliyuncs.com/1/ab57c441-6d27-43a5-92ad-bf5a1891f747.png', // 分享图标
                    success: function () {
                    }
                  })
                })
                clearInterval(timer)
              } else {
                wxdata.config.signature = response.data
              }
            }, 200)
          }
        })
      }
    },
    watch: {
      '$store.state.session.timeout': function(val) {
        if (val) {
          clearInterval(this.timer)
        }
      },
      '$route' (to, from) {
        // IOS系统的分享，初始化需要在路径初始化的时候就设置config
        if (to.path === '/') {
          // next()
          if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
            this.wxShare()
          }
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/App.vue